import React from 'react';

const TataLaksanaKerja = () => {
    return (
        <section className="bg-white pt-10">
            <div className="container mx-auto pt-10">
                {/* Header Section */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-[#005da2] mb-6 text-center" data-aos="fade-down">Tata Laksana Kerja Direksi dan Dewan Komisaris</h2>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify" data-aos="fade-down">
                        Board Manual merupakan pedoman yang mengatur hubungan kerja antara Direksi dan Dewan Komisaris dalam menjalankan tugas, sehingga pengelolaan perusahaan dapat dilakukan secara profesional, transparan, dan efisien. Berdasarkan ketentuan peraturan perundang-undangan serta Anggaran Dasar yang berlaku, Direksi dan Dewan Komisaris telah menyetujui penerapan Board Manual PT Len Telekomunikasi Indonesia.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify py-5" data-aos="fade-down">
                        Dalam menjalankan aktivitasnya, Direksi dan Dewan Komisaris berpedoman pada Board Manual yang mencakup ketentuan terkait etika kerja, ketentuan jam kerja, serta tata cara penyelenggaraan rapat. Direksi dan Dewan Komisaris PT Len Telekomunikasi Indonesia wajib mematuhi seluruh peraturan perundang-undangan, Anggaran Dasar perusahaan, serta menerapkan prinsip profesionalisme, efisiensi, transparansi, akuntabilitas, tanggung jawab, independensi, dan kewajaran.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default TataLaksanaKerja;
